import React from "react";

export default function Base({ children }) {
  return <>{children}</>;
}
